<script>
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'
import apiExceptionType from '@/utils/apiExceptionType'
import subportionService from '@/modules/diagnosisModule/services/subportionService'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'

export default {
    name: 'DiagnosisMixin',
    methods: {
        async internalValidateCaseMixin(laboratoryId, caseId, ignoreWarnings = false) {
            this.updateLoading(true)
            let err
            if (ignoreWarnings) {
                [err] = await this.toCall(diagnosisCaseService.validateCaseIgnoringWarnings(laboratoryId, caseId))
            } else {
                [err] = await this.toCall(diagnosisCaseService.validateCase(laboratoryId, caseId))
            }
            this.updateLoading(false)
            if (err) {
                if (err.response && err.response.data) {
                    if (err.response.data.code === apiExceptionType.CASE_VALIDATION_ABORT) {
                        const situations = this.formatSituations(err.response.data.situations)
                        this.showErrorModalGlobal(this.$t('diagnosis.errors.caseValidationError', { situations }))
                        return false
                    } else if (err.response.data.code === apiExceptionType.CASE_VALIDATION_WARNING) {
                        const situations = this.formatSituations(err.response.data.situations)
                        if (await this.showConfirmationModalGlobal(this.$t('diagnosis.errors.caseValidationWarning', { situations }), this.$t('global.yes'), this.$t('global.no'), 'confirmationModalGlobal-InternalValidateCaseMixin')) {
                            return this.internalValidateCaseMixin(laboratoryId, caseId, true)
                        }
                        return false
                    }
                }
                this.$_showErrorModalFromErrorResponse(err)
                return false
            }
            return true
        },
        formatSituations(situations) {
            return situations.map(situation => `<p>${situation}</p>`).join('')
        },
        isCorrectPathologistAssigned(
            operationCode,
            pathologistPersonnelId,
            loggedInPersonnelId,
            pathologistAllowsCaseValidationByOtherUsers,
            laboratoryId) {
            return pathologistPersonnelId &&
                (loggedInPersonnelId === pathologistPersonnelId ||
                    (operationCode &&
                        pathologistAllowsCaseValidationByOtherUsers &&
                        this.$_hasLabOperation(laboratoryId, operationCode)))
        },

        async onSubportionSearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    subportionService.searchSubportionByLabel(searchInformation.search),
                    error => {
                        if (error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND) {
                            this.$_showErrorModal(this.$tc('component.searcher.error.noSubportion'))
                        } else {
                            this.$_showErrorModalFromErrorResponse(error)
                        }
                    })

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.SUBPORTION,
                            entityValue: entity,
                            laboratoryId: entity.portion.sample.caseStudy.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)
                }

                await this.goToDiagnosisSubportionView(entitySelected)
            }
        },
        async onStudySearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    diagnosisCaseService.searchCaseByLabel(searchInformation.search),
                    error => {
                        if (error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND) {
                            this.$_showErrorModal(this.$tc('component.searcher.error.noCase'))
                        } else {
                            this.$_showErrorModalFromErrorResponse(error)
                        }
                    })
            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.CASE,
                            entityValue: entity,
                            laboratoryId: entity.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)
                }
                await this.goToDiagnosisCaseView(entitySelected.laboratory.labId, entitySelected.casId)
            }
        },

        async goToDiagnosisSubportionView(subportion) {
            const navigationConfirmed = await this.$_confirmNavigationBecauseOfLaboratoryChange(subportion.portion.sample.caseStudy.laboratory.labId)
            if (navigationConfirmed) {
                this.$router.push({
                    name: 'diagnosisCaseInform',
                    params: {
                        labId: subportion.portion.sample.caseStudy.laboratory.labId,
                        casId: subportion.portion.sample.caseStudy.casId,
                        samId: subportion.portion.sample.samId,
                        porId: subportion.portion.porId
                    }
                })
            }
        },
        async goToDiagnosisCaseView(laboratoryId, caseId) {
            const navigationConfirmed = await this.$_confirmNavigationBecauseOfLaboratoryChange(laboratoryId)
            if (navigationConfirmed) {
                this.preventClick = true
                const newRouteName = 'diagnosisCaseInform'
                if (this.isRouteEqualToCurrentRoute(newRouteName, laboratoryId, caseId)) {
                    this.$_showWarningModal(this.$tc('diagnosis.errors.caseAlreadyLoaded'))
                } else {
                    this.updateLoading(true)
                    this.$router.push({
                        name: newRouteName,
                        params: {
                            labId: laboratoryId,
                            casId: caseId
                        }
                    })
                }
            }
        },
        isRouteEqualToCurrentRoute(routeName, laboratoryId, caseId) {
            // noinspection EqualityComparisonWithCoercionJS
            return this.$route.name === routeName &&
                // eslint-disable-next-line eqeqeq
                this.$route.params.labId == laboratoryId &&
                // eslint-disable-next-line eqeqeq
                this.$route.params.casId == caseId
        }
    }
}
</script>
